import { useCallback, useReducer } from "react";
function reducer(state, action) {
  switch (action.type) {
    case "setTab":
      return {
        ...state,
        tab: action.tab
      };
    case "setShowAdvancedSettings":
      return {
        ...state,
        showAdvancedSettings: action.showAdvancedSettings
      };
    default:
      return state;
  }
}
function usePreviewTheme() {
  const [state, dispatch] = useReducer(reducer, {
    showAdvancedSettings: false,
    tab: 0
  });
  const handleTabChange = useCallback((_, newValue) => {
    dispatch({ tab: newValue, type: "setTab" });
  }, []);
  const handleCloseAdvancedSettingsModal = useCallback(() => {
    dispatch({ showAdvancedSettings: false, type: "setShowAdvancedSettings" });
  }, []);
  const handleOpenAdvancedSettingsModal = useCallback(() => {
    dispatch({ showAdvancedSettings: true, type: "setShowAdvancedSettings" });
  }, []);
  return {
    ...state,
    handleCloseAdvancedSettingsModal,
    handleOpenAdvancedSettingsModal,
    handleTabChange
  };
}
export {
  usePreviewTheme
};
//# sourceMappingURL=usePreviewTheme.js.map
